import url from '@/utils/url'
import { atu, map } from '@/api/api-endpoints'
import L from 'leaflet'
import { COLORS } from '@/utils'
import { MARKER_ICON } from '@/config/map'
import urlUtil from '@/utils/url'
import { revertCoords } from '@/utils/map/geo'

const SELECTED_TYPES = {
  geo: 'geo',
  object: 'object',
}
export default {
  data() {
    return {
      selectedGeoId: null,
      selectedGeoName: null,
      deltas: {},
      threadYear: null,
    }
  },
  methods: {
    async setSelectedType(type, thread_id, thread_geo_object_id) {
      switch (type) {
        case SELECTED_TYPES.geo:
          await this.showMunicipalities(thread_id)
          break
        case SELECTED_TYPES.object:
          await this.showObjects(thread_id, thread_geo_object_id)
          break
        default:
          return false
      }
    },
    async showMunicipalities(threadId) {
      const objects = await (
        await this.$store.dispatch('updateUrlEndpoint', {
          endpoint: atu.atuObjectUpdateOrCreate(),
          fromCache: false,
          notReactive: false,
        })
      ).data.data
      const mainBorderLayer = L.layerGroup()

      objects.map((border) => {
        let polygon = JSON.parse(border.geo_json).coordinates

        if (polygon) {
          polygon = polygon.flat()
          polygon = revertCoords(polygon)
          const poly = L.polygon(polygon, {
            color: COLORS.red,
            fillColor: COLORS.red,
            fillOpacity: 0,
            weight: 2,
            opacity: 0.5,
          })
          const popup = L.popup()
          popup.setContent(
            this.addContentToPopupZone(border, threadId, SELECTED_TYPES.geo)
          )
          poly.bindPopup(popup)
          mainBorderLayer.addLayer(poly)
        }
      })

      mainBorderLayer.addTo(this.map)
      this.addActionsToZonePopup()
    },
    addContentToPopupZone(item, threadId, type) {
      return `<div class='map-popup'>
                <div class="map-popup__header">
                    <div class="map-popup__title">Вы выбрали</div>
                </div>
                <div class="map-popup__body">
                     <div class='map-popup__name semibold'>${item.name}</div>
                </div>
                <div class="map-popup__footer">
                  <div class='map-popup__buttons'>
                    <button class='reset-btn button map-popup__button button_delete js-cancel-choice'>Отменить выбор</button>
                    <button class='reset-btn button map-popup__button js-select-object'
                     data-thread-id='${threadId}'
                     data-id='${item.id}'
                     data-name='${item.name}'
                     data-type='${type}'
                     >Потвердить</button>
                  </div>
                </div>
            </div>
        `
    },
    addActionsToZonePopup() {
      document.addEventListener('click', async (e) => {
        if (e.target.classList.contains('js-cancel-choice')) {
          this.map?.closePopup()
        }
        if (e.target.classList.contains('js-select-object')) {
          const threadId = Number(e.target.dataset.threadId)
          const objectId = e.target.dataset.id
          const objectName = e.target.dataset.name
          const type = e.target.dataset.type
          let route = this.$route
          if (type === SELECTED_TYPES.geo) {
            this.selectedGeoId = objectId
            this.selectedGeoName = objectName
          }
          if (type === SELECTED_TYPES.object) {
            const usedRoute = url.getPrevOrCurrentRoute(this.$route)
            this.deltas[usedRoute.params.delta] = {
              selectedObjectId: objectId,
              selectedObjectName: objectName,
            }
          }
          route.params.deltas = this.deltas
          route.params.selectedGeoId = this.selectedGeoId
          route.params.selectedGeoName = this.selectedGeoName
          route.params.threadYear = this.threadYear

          route = url.getRoute(route, true)
          route = urlUtil.encode(route)
          route.name = 'access.threads'
          delete route.query
          route = urlUtil.decode(route)

          this.$router.push({
            name: 'access.threads.update',
            params: { id: threadId },
            query: {
              prevRoute: route,
            },
          })
        }
      })
    },
    async showObjects(threadId, thread_geo_object_id) {
      const objectsLayers = L.markerClusterGroup()
      const objects = await (
        await this.$store.dispatch('updateUrlEndpoint', {
          endpoint: map.objectForThreads({ query: { thread_geo_object_id } }),
          fromCache: false,
          notReactive: false,
        })
      ).data
      const flatObjects = []

      Object.values(objects).forEach((object) => {
        Object.values(object).forEach((item) => {
          flatObjects.push(item)
        })
      })
      flatObjects.forEach((el) => {
        const marker = L.marker([el.lat, el.lng], {
          icon: MARKER_ICON,
        })
        const popup = L.popup()
        popup.setContent(
          this.addContentToPopupZone(el, threadId, SELECTED_TYPES.object)
        )
        marker.bindPopup(popup)
        objectsLayers.addLayer(marker)
      })
      this.map.addLayer(objectsLayers)
      this.addActionsToZonePopup()
    },
  },
  created() {
    const usedRoute = url.getPrevOrCurrentRoute(this.$route)
    const previousParams = url.getPrevOrCurrentRoute(usedRoute).params
    if (previousParams.selectedGeoId) {
      this.selectedGeoId = previousParams.selectedGeoId
    }
    if (previousParams.selectedGeoName) {
      this.selectedGeoName = previousParams.selectedGeoName
    }
    if (previousParams.deltas) {
      this.deltas = previousParams.deltas
    }
    if (usedRoute.params.threadYear) {
      this.threadYear = usedRoute.params.threadYear
    }
    if (usedRoute.params.selectedType) {
      this.hasRegopFilter = false
      this.setSelectedType(
        usedRoute.params.selectedType,
        usedRoute.params.thread_id,
        usedRoute.params.thread_geo_object_id
      )
    }
  },
}
